/**
2  *  Copyright (c) 2021 Micro Focus Software Inc.  All Rights Reserved.
3  *
4  * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
5  * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
6  * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
7  * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
8  * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
9  * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
10  * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
11  * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
12  * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
13  * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
14  * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
15  */
import { Component, ViewEncapsulation, OnInit, Output, EventEmitter, HostListener } from '@angular/core';
import { OutagesService } from '../services/outages.service';
import { ActivatedRoute } from '@angular/router';
import { ZSDTranslateService } from '../../../../common/zsd-translate.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { PlannedOutagesBasicInfo, PlannedOutagesResponse } from '../model/plannedoutagesresponse';
import { OutagesFilterInfo } from '../model/outagesfilterinfo';
import { BannerComponent } from '../../../../customer/view/banner/banner.component';
import { SpinnerService } from '../../../../shared/spinner/spinner.service';
import { CustomerPreferenceResponse } from '../../../../customer/preference/customerpreference.model';
import { CustomerPreferenceService } from '../../../../customer/preference/customerpreference.service';
import { take } from 'rxjs/operators';

declare var $: any;
declare var moment: any;

@Component({
    selector: 'zsd-plannedoutages',
    templateUrl: '../view/planned-outageslist.component.html',
    styleUrls: ['../view/planned-outageslist.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class PlannedOutagesComponent implements OnInit {
    plannedOutagesResponse: PlannedOutagesBasicInfo[] = [];
    plannedOutagesResultsCount = 0;
    plannedOutagesPerPage = 20;
    page = 0;
    sortBy = 'startDate';
    sortOrder = 'DESC';
    isLoading = false;
    maxNoOfItems;
    isPlannedOutageslist;
    scrollEndReached = false;
    isDesc = true;
    column;
    canCustomerViewOutages: boolean;

    plannedOutagesBasicInfoResponse = new Array<PlannedOutagesBasicInfo>();
    plannedOutagesListResponse: PlannedOutagesResponse = new PlannedOutagesResponse();
    outagesFilterInfo: OutagesFilterInfo = new OutagesFilterInfo();
    spinnerStart = true;

    static startFromDate: string;
    static startToDate: string;
    static sun: string;
    static mon: string;
    static tue: string;
    static wed: string;
    static thu: string;
    static fri: string;
    static sat: string;
    static jan: string;
    static feb: string;
    static mar: string;
    static apr: string;
    static may: string;
    static jun: string;
    static jul: string;
    static aug: string;
    static sep: string;
    static oct: string;
    static nov: string;
    static dec: string;
    @Output() openfilter = new EventEmitter<boolean>();

    constructor(public outagesService: OutagesService, private route: ActivatedRoute,
        public zsdTranslate: ZSDTranslateService, public http: HttpClient,
        public spinnerService: SpinnerService, private custpreferences: CustomerPreferenceService) {
          if (this.zsdTranslate.getTranslateService().store.translations[this.zsdTranslate.getTranslateService().currentLang]) { // check if translated json file already available
            this.initializeDateTimePicker()
          } else {
            this.zsdTranslate.getTranslateService().onDefaultLangChange.pipe(take(1)).subscribe(_ =>     this.initializeDateTimePicker()); // wait for new translated json file to get loaded by subscribing to it 
          } 
    }

    ngOnInit() {
      /* $(document).ready(() => {
        this.initializeDateTimePicker();
      }); */
      this.custpreferences.getPreferenceList().toPromise()
      .then(
          (customerpreferenceResponse: CustomerPreferenceResponse) => {
            this.canCustomerViewOutages = customerpreferenceResponse.canCustomerViewOutages;
            if (this.canCustomerViewOutages) {
              this.initOutagesListCount();
            }
          }
      );
      /* To refresh Global search dropdown */
    BannerComponent.refreshGlobalSearchDropdown.next(false);
    this.sort('startDate');
    $(document).ready(() => {
    $('#reportranged').on('apply.daterangepicker', () => {
        this.initializeItemsParameters();
        this.outagesFilterInfo.startFromDate = PlannedOutagesComponent.startFromDate;
        this.outagesFilterInfo.startToDate = PlannedOutagesComponent.startToDate;
        this.initFilter();
        this.applyFilterParamaeter(this.outagesFilterInfo);
      });
    });
    }

    sort(property) {
        this.initializeItemsParameters();
        $('#property').removeClass('fa fa-sort');
        this.isDesc = !this.isDesc;
        this.column = property;
        if (this.isDesc === true) {
            this.sortOrder = 'ASC';
        } else {
            this.sortOrder = 'DESC';
        }
        this.sortBy = property;

        this.initFilter();
        this.applyFilterParamaeter(this.outagesFilterInfo);
        this.isLoading = true;
        this.spinnerService.show();

    }

    applyFilterParamaeter(outagesFiterInfo: OutagesFilterInfo) {

        if (outagesFiterInfo) {
            this.getPlannedOutagesList(this.page, this.sortBy, this.sortOrder, outagesFiterInfo);
        } else {
            outagesFiterInfo.searchTerm = '';
            outagesFiterInfo.categoryIds = [];
            outagesFiterInfo.itemTypeIds = [];
            outagesFiterInfo.startFromDate = null;
            outagesFiterInfo.startToDate = null;
            this.getPlannedOutagesList(this.page, this.sortBy, this.sortOrder, outagesFiterInfo);
        }
       }




    initFilter() {
        let categoryIds = new Array<number>();
        let itemTypeIds = new Array<number>();

        this.route.queryParams.subscribe(params => {
            if (params['searchTerm']) {
                this.outagesFilterInfo.searchTerm = JSON.parse(params['searchTerm']);
            }
            if (params['categoryIds']) {
                categoryIds = JSON.parse(params['categoryIds']);
            }
            if (params['itemTypeIds']) {
                itemTypeIds = JSON.parse(params['itemTypeIds']);
            }
            this.outagesFilterInfo.categoryIds = categoryIds;
            this.outagesFilterInfo.itemTypeIds = itemTypeIds;
        });
    }

    getPlannedOutagesList(pageNo: number, sortBy: string, sortOrder: string, outagesFilterInfo: OutagesFilterInfo) {
        let params = new HttpParams()
            .set('offset', this.page.toString())
            .set('limit', this.plannedOutagesPerPage.toString())
            .set('sortBy', this.sortBy)
            .set('sortOrder', this.sortOrder);
            if (!this.isLoading) {
                this.isLoading = true;
                this.spinnerService.show();
                if (pageNo === -1) {
                    this.isLoading = true;
                    this.spinnerService.show();
                    this.page = 0;
                    this.sortBy = sortBy;
                    this.sortOrder = sortOrder;
                    this.initializeItemsParameters();
                    pageNo = 0;
                }
        }
            this.outagesService.getPlannedOutagesList(params, outagesFilterInfo)
            .subscribe(
                (plannedOutagesResponse: PlannedOutagesResponse) => {
                    this.maxNoOfItems = plannedOutagesResponse.resultCount;
                    if ( this.maxNoOfItems > 0) {
                        this.isPlannedOutageslist = true;
                        this.scrollEndReached = false;
                    }
                     this.plannedOutagesBasicInfoResponse = this.plannedOutagesBasicInfoResponse.concat(
                         plannedOutagesResponse.results
                     );
                     this.page++;
                     if ( this.plannedOutagesBasicInfoResponse.length >= this.maxNoOfItems) {
                        this.scrollEndReached = true;
                     }
                     this.isLoading = false;
                     this.spinnerStart = false;
                },

                err => {
                    console.error(err.error);
                    this.isLoading = false;
                    this.spinnerStart = false;
                    this.isPlannedOutageslist = false;
                }
            );
    }
    initOutagesListCount() {
      let params = new HttpParams()
              .set('offset', '0')
              .set('limit', '1');
      this.outagesService.getOutagesList(params).subscribe();
  }
    initializeItemsParameters() {
        this.isLoading = false;
        this.page = 0;
        this.isPlannedOutageslist = false;
        this.plannedOutagesBasicInfoResponse = [];
        this.outagesFilterInfo = new OutagesFilterInfo();
        this.plannedOutagesListResponse = new PlannedOutagesResponse();
    }
    initializeDateTimePicker() {
      let allLabel = this.zsdTranslate.getTranslatedString('CommonStrings', 'all');
      let customLabel = this.zsdTranslate.getTranslatedString('CommonStrings', 'custom');
      let applyLabel = this.zsdTranslate.getTranslatedString('CommonStrings', 'applyButton');
      let cancelLabel = this.zsdTranslate.getTranslatedString('CommonStrings', 'cancelButton');
      PlannedOutagesComponent.sun = this.zsdTranslate.getTranslatedString('CommonStrings', 'sun');
      PlannedOutagesComponent.mon = this.zsdTranslate.getTranslatedString('CommonStrings', 'mon');
      PlannedOutagesComponent.tue = this.zsdTranslate.getTranslatedString('CommonStrings', 'tue');
      PlannedOutagesComponent.wed = this.zsdTranslate.getTranslatedString('CommonStrings', 'wed');
      PlannedOutagesComponent.thu = this.zsdTranslate.getTranslatedString('CommonStrings', 'thu');
      PlannedOutagesComponent.fri = this.zsdTranslate.getTranslatedString('CommonStrings', 'fri');
      PlannedOutagesComponent.sat = this.zsdTranslate.getTranslatedString('CommonStrings', 'sat');
      PlannedOutagesComponent.jan = this.zsdTranslate.getTranslatedString('CommonStrings', 'jan');
      PlannedOutagesComponent.feb = this.zsdTranslate.getTranslatedString('CommonStrings', 'feb');
      PlannedOutagesComponent.mar = this.zsdTranslate.getTranslatedString('CommonStrings', 'mar');
      PlannedOutagesComponent.apr = this.zsdTranslate.getTranslatedString('CommonStrings', 'apr');
      PlannedOutagesComponent.may = this.zsdTranslate.getTranslatedString('CommonStrings', 'may');
      PlannedOutagesComponent.jun = this.zsdTranslate.getTranslatedString('CommonStrings', 'jun');
      PlannedOutagesComponent.jul = this.zsdTranslate.getTranslatedString('CommonStrings', 'jul');
      PlannedOutagesComponent.aug = this.zsdTranslate.getTranslatedString('CommonStrings', 'aug');
      PlannedOutagesComponent.sep = this.zsdTranslate.getTranslatedString('CommonStrings', 'sep');
      PlannedOutagesComponent.oct = this.zsdTranslate.getTranslatedString('CommonStrings', 'oct');
      PlannedOutagesComponent.nov = this.zsdTranslate.getTranslatedString('CommonStrings', 'nov');
      PlannedOutagesComponent.dec = this.zsdTranslate.getTranslatedString('CommonStrings', 'dec');

       $(function() {
         $('#reportranged span').html(allLabel);
         let start = moment();
         let end = moment();
         $('#reportranged').daterangepicker({
             minDate: start,
             startDate: start,
             endDate: end,
             timePicker: false,
             showDropdowns: true,
             opens: 'left',
             timePickerIncrement: false,
             alwaysShowCalendars: false,
             linkedCalendars: false,
             locale: {
              'format': 'MM/DD/YYYY',
              'applyLabel': applyLabel,
              'cancelLabel': cancelLabel,
              'customRangeLabel': customLabel,
              'daysOfWeek': [
                PlannedOutagesComponent.sun,
                PlannedOutagesComponent.mon,
                PlannedOutagesComponent.tue,
                PlannedOutagesComponent.wed,
                PlannedOutagesComponent.thu,
                PlannedOutagesComponent.fri,
                PlannedOutagesComponent.sat
                ],
              'monthNames': [
                PlannedOutagesComponent.jan,
                PlannedOutagesComponent.feb,
                PlannedOutagesComponent.mar,
                PlannedOutagesComponent.apr,
                PlannedOutagesComponent.may,
                PlannedOutagesComponent.jun,
                PlannedOutagesComponent.jul,
                PlannedOutagesComponent.aug,
                PlannedOutagesComponent.sep,
                PlannedOutagesComponent.oct,
                PlannedOutagesComponent.nov,
                PlannedOutagesComponent.dec
              ]
            },
             ranges: {
                [allLabel]: [moment(), moment()],
             }
         },  function(startDate, endDate, label) {
                if (label === allLabel) {
                  $('#reportranged span').html(allLabel);
                  PlannedOutagesComponent.startFromDate = null;
                  PlannedOutagesComponent.startToDate = null;
                } else {
                     $('#reportranged span').html(customLabel);
                     PlannedOutagesComponent.startFromDate =  startDate.format('MM/D/YY');
                     PlannedOutagesComponent.startToDate = endDate.format('MM/D/YY');
                }
         });
       });
     }

     scrollEnd() {
        if (!this.scrollEndReached) {
          this.initFilter();
          this.getPlannedOutagesList(this.page, this.sortBy, this.sortOrder, this.outagesFilterInfo);
        }
      }
      scrollCur() {
      }

      trackByPlannedOutages(index) {
        return index;
      }
      @HostListener('window:beforeunload', ['$event']) unloadHandler() {
        new PlannedOutagesComponent(
            this.outagesService,
            this.route,  this.zsdTranslate,  this.http,
            this.spinnerService, this.custpreferences );
        window.scrollTo(0, 0);
      }
    openFilter() {
        this.openfilter.emit(true);
    }

    showOutageReason(outageReason: string): string {
        if (outageReason.length > 50) {
            return outageReason.slice(0, 50).concat('...');
        }
        return outageReason;
    }
}
